import { Progress } from "@/components/ui/progress";
import { SettingsThresholds } from "@/entities/settings/types";
import { cn } from "@/utils/utils";
import { useTranslation } from "react-i18next";

interface Props {
  value: number;
  levels?: SettingsThresholds;
  className?: string;
}

const HorizBarPercentage = ({ value, levels, className }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <span>{value === -1 ? t("unknown") : `${value.toFixed(0)}%`}</span>
      <Progress value={value} levels={levels} />
    </div>
  );
};

export default HorizBarPercentage;
